import { useState, useEffect } from 'react';
import { pushSupporte, estInstallee, permission, activerNotifications,
         desactiverNotifications, estAbonne, testerNotification } from '../push';

export default function NotificationsCard({ onToast }) {
  const [abonne, setAbonne] = useState(false);
  const [charge, setCharge] = useState(true);
  const [busy, setBusy]     = useState(false);
  const supporte  = pushSupporte();
  const installee = estInstallee();
  const perm      = permission();
  const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

  useEffect(() => { estAbonne().then(a => { setAbonne(a); setCharge(false); }); }, []);

  function toast(msg, type='success') { if (onToast) onToast(msg, type); }

  async function activer() {
    setBusy(true);
    try { await activerNotifications(); setAbonne(true); toast('🔔 Notifications activées'); }
    catch (e) { toast(e.message, 'error'); }
    finally { setBusy(false); }
  }
  async function desactiver() {
    setBusy(true);
    try { await desactiverNotifications(); setAbonne(false); toast('Notifications désactivées'); }
    catch (e) { toast(e.message, 'error'); }
    finally { setBusy(false); }
  }
  async function tester() {
    setBusy(true);
    try { await testerNotification(); toast('Notification envoyée'); }
    catch (e) { toast(e.message, 'error'); }
    finally { setBusy(false); }
  }

  if (charge) return null;

  if (iOS && !installee) {
    return (
      <div className="card" style={{ marginBottom:14, borderColor:'rgba(234,179,8,0.3)', background:'rgba(234,179,8,0.05)' }}>
        <div style={{ fontSize:13, fontWeight:700, marginBottom:6 }}>🔔 Notifications</div>
        <div style={{ fontSize:12, color:'#8b949e', lineHeight:1.6 }}>
          Pour recevoir les convocations et les sanctions sur ton iPhone, installe d'abord l'application :
          bouton <b>Partager</b> puis <b>Sur l'écran d'accueil</b>. Reviens ensuite ici pour les activer.
        </div>
      </div>
    );
  }

  if (!supporte) {
    return (
      <div className="card" style={{ marginBottom:14 }}>
        <div style={{ fontSize:13, fontWeight:700, marginBottom:6 }}>🔔 Notifications</div>
        <div style={{ fontSize:12, color:'#8b949e' }}>
          Ton navigateur ne gère pas les notifications. Essaie Chrome sur Android ou Safari sur iPhone.
        </div>
      </div>
    );
  }

  return (
    <div className="card" style={{ marginBottom:14,
      borderColor: abonne ? 'rgba(34,197,94,0.3)' : 'rgba(59,130,246,0.3)',
      background:  abonne ? 'rgba(34,197,94,0.05)' : 'rgba(59,130,246,0.05)' }}>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', gap:10, flexWrap:'wrap' }}>
        <div style={{ minWidth:0 }}>
          <div style={{ fontSize:13, fontWeight:700 }}>
            🔔 Notifications {abonne && <span style={{ color:'#22c55e', fontSize:11 }}>· activées</span>}
          </div>
          <div style={{ fontSize:11.5, color:'#8b949e', marginTop:3, lineHeight:1.5 }}>
            {abonne
              ? 'Tu reçois les convocations, les sanctions et les rappels la veille.'
              : perm === 'denied'
                ? 'Tu as bloqué les notifications. Réactive-les dans les réglages de ton navigateur.'
                : 'Sois prévenu des convocations, sanctions et rappels.'}
          </div>
        </div>
        <div style={{ display:'flex', gap:7, flexShrink:0 }}>
          {abonne ? (
            <>
              <button onClick={tester} disabled={busy}
                style={{ background:'none', border:'1px solid rgba(255,255,255,0.12)', borderRadius:8,
                  color:'#8b949e', cursor:'pointer', fontSize:11, padding:'8px 11px' }}>Test</button>
              <button onClick={desactiver} disabled={busy}
                style={{ background:'none', border:'1px solid rgba(239,68,68,0.3)', borderRadius:8,
                  color:'#ef4444', cursor:'pointer', fontSize:11, padding:'8px 11px' }}>Couper</button>
            </>
          ) : (
            <button onClick={activer} disabled={busy || perm === 'denied'}
              style={{ background:'#3b82f6', border:'none', borderRadius:8, color:'#fff',
                cursor: perm === 'denied' ? 'not-allowed' : 'pointer', fontSize:12, fontWeight:700,
                padding:'9px 15px', opacity: perm === 'denied' ? 0.4 : 1, whiteSpace:'nowrap' }}>
              {busy ? '…' : 'Activer'}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
